import React from 'react';

const ImageCard = ({ title, description, link, linkText, ds_link }) => {
    return (
        <div className="card lg:w-[288px] xl:w-[288px] md:w-[288px] w-[238px] bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="card__info p-4">
                <a 
                    href={link} 
                    target="_blank" 
                    rel="noreferrer" 
                    className="card__category font-bold text-sm block hover:text-[#bc8b20] transition-colors mt-2"
                >
                    {title}
                </a>
                <a href={ds_link} className="block">
                    <p className="card__title font-medium text-[15px] text-gray-700 hover:text-gray-900 transition-colors mt-0">
                        {description}
                    </p>
                </a>
                
            </div>
        </div>
    );
};

export default ImageCard;